import ReactDOM from "react-dom/client";
import "../../../lib/index.css";
import "./index.css";
import logo from "./assets/logo.webp";
import { app, App } from "../../../lib";
import { Helmet } from "react-helmet";

app.country = 11;
app.zendeskDomain = "signpost-pakistan";
app.zendeskBrandId = 360007039593;
app.logo = logo;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    <Helmet>
      <title>InfoYahan</title>
      <meta name="description" content="Information on services in Pakistan." />
      <meta property="og:title" content="InfoYahan" />
      <meta property="og:description" content="Information on services in Pakistan." />
      <meta property="og:image" content={logo} />
      <meta property="og:url" content="https://www.infoyahan.org/" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="InfoYahan" />
      <meta name="twitter:description" content="Information on services in Pakistan." />
      <meta name="twitter:image" content={logo} />
    </Helmet>
    <App />
  </>
);
